import type { GetMemberPolicyData } from 'api/dist/routes/organization/[organization_id]/members/policy/index.js'
import type { IApi } from '@/setup/api-client'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { useApiQuery } from '@/utils/api/api-query'

interface IGetMembersPolicyParams {
    organizationId: string
}

export type IMembersPolicy = GetMemberPolicyData

/** Reads current-user membership policy from the server's fresh Clerk state. */
export class GetMembersPolicyQuery {
    static getKey(params: IGetMembersPolicyParams) {
        // 'members-policy' stays out of the members-list namespace: the search key
        // ['organization', id, 'members', <query>] would collide for the literal search "policy".
        return ['organization', params.organizationId, 'members-policy']
    }

    static call(api: IApi, params: IGetMembersPolicyParams) {
        return api
            .get<GetMemberPolicyData>(`/organization/${params.organizationId}/members/policy`)
            .then((response) => response.data)
    }
}

/** Returns whether the current user may leave the active workspace. */
export function useGetMembersPolicyQuery() {
    const { api, apiParams } = useApiToolbox()

    return useApiQuery({
        queryKey: GetMembersPolicyQuery.getKey(apiParams),
        queryFn: () => GetMembersPolicyQuery.call(api, apiParams),
        enabled: !!apiParams.organizationId,
    })
}
